module.exports = __webpack_public_path__ + "static/media/tca1.75e14d5b.png";